import React, { FC, ReactNode } from 'react';

import classNames from 'classnames';

import {
	EvSection,
	EvSpinner,
	EvSwitch,
	TABLE_FILTERS_SR_SUMMARY
} from '@evinced-private/ui-common';

import {
	SHOW_ONLY_LATEST_TESTS_TOGGLE_ID,
	WEB_SDK_TESTS_PAGE_FILTERS_SECTION_ID
} from 'data-automation-ids/WebSdkDataAutomationIds';

interface FilterSectionCommonProps {
	isFilterOptionsLoading: boolean;
	showRecentTest: boolean;
	onShowRecentTestChange: () => void;
	showTestPath: boolean;
	children: ReactNode;
}

export const FilterSectionCommon: FC<FilterSectionCommonProps> = ({
	isFilterOptionsLoading,
	showRecentTest,
	onShowRecentTestChange,
	showTestPath,
	children
}) => {
	return (
		<EvSection
			ariaLabel="WEB SDK All Tests filters"
			ariaDescribedby={TABLE_FILTERS_SR_SUMMARY}
			ariaLive="polite"
			skipLinkId="filters-section"
			className={classNames('dashboard-section', 'web-sdk-tests-filters-section')}
			dataAutomationId={WEB_SDK_TESTS_PAGE_FILTERS_SECTION_ID}
		>
			{isFilterOptionsLoading ? (
				<EvSpinner />
			) : (
				<div className="filters-area">
					<div className="filter-line">{children}</div>
					<EvSwitch
						dataAutomationId={SHOW_ONLY_LATEST_TESTS_TOGGLE_ID}
						onChange={onShowRecentTestChange}
						checked={showRecentTest}
						label="Show only the last report per test"
						className="show-only-most-recent-results-toggle"
					/>
					<span className="sr-only" aria-live="assertive">
						{showTestPath
							? 'Showing full test paths in test name column'
							: 'Not showing test path in test name column'}
					</span>
				</div>
			)}
		</EvSection>
	);
};
